import React from "react";
import { Button, CircularProgress, ButtonProps } from "@mui/material";

export interface BtnLoadingProps extends ButtonProps {
    loading?: boolean;
    loadingText?: string;
    children: React.ReactNode;
}

export default function BtnLoading({
    loading = false,
    loadingText,
    children,
    startIcon,
    endIcon,
    variant = "contained",
    color = "primary",
    size = "medium",
    disabled,
    ...props
}: BtnLoadingProps) {
    
    const getLoadingSize = () => {
        switch (size) {
            case "small":
                return 16;
            case "large":
                return 24;
            default:
                return 20;
        }
    };

    return (
        <Button
            {...props}
            variant={variant}
            color={color}
            size={size}
            disabled={loading || disabled}
            startIcon={loading ? undefined : startIcon}
            endIcon={loading ? undefined : endIcon}
        >
            {loading && (
                <CircularProgress 
                    size={getLoadingSize()} 
                    color="inherit" 
                    sx={{ mr: 1 }} 
                />
            )}
            {loading ? (loadingText || "Carregando...") : children}
        </Button>
    );
}
